<template>
    <div class="list-wrapper">
        <talk-list :fromPath="fromPath" ref="talkList"></talk-list>     
    </div>
</template>

<script>
    import TalkList from './List';
    export default {
        name: 'TalkAll',

        components: {TalkList},

        data() {
            return {
                fromPath: ''
            }
        },

        beforeRouteEnter(to, from, next) { 
            next(vm => {
                if(from.path === "/publish" || from.path === "/publish-we-chat" || from.path === "/publish-app" || from.path === "/publish-article") {
                    vm.$refs.talkList.onRefresh()
                }
                vm.fromPath = from.path
            })
        }  
    }
</script>

<style scoped>
</style>